export class UserSetting {
    public section: string;
    public key: string;
    public value: string;

    constructor(settings: Partial<UserSetting> = {}) {
        Object.assign(this, settings);
    }
}
